import ThiSensorApi from "@/api/thi-sensor-api";
import i18n from "@/plugins/i18n";

export default {
  name: "EditThiSensorModal",
  props: {
    sensor: { type: Object, required: true },
    reload: Function
  },
  data() {
    return {
      isLoading: false,
      serverError: null,
      form: {
        deveui: null,
        name: null,
        description: null
      }
    };
  },
  mounted() {
    this.form.deveui = this.sensor.deveui;
    this.form.name = this.sensor.name;
    this.form.description = this.sensor.description;
  },
  methods: {
    async save() {
      this.serverError = null;
      this.isLoading = true;
      try {
        const response = await ThiSensorApi.update(this.sensor.thi_sensor_id, {
          name: this.form.name,
          description: this.form.description
        });

        if (response && response.status === 200) {
          if (this.reload) {
            this.reload();
          }
          this.close();
        } else {
          this.serverError = (response && response.data) || i18n.t("thiSensorDetails.errors.generic");
        }
      } catch (e) {
        this.serverError = i18n.t("thiSensorDetails.errors.generic");
      } finally {
        this.isLoading = false;
      }
    },
    close() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/edit-thi-sensor/edit-thi-sensor-modal.js